export default __webpack_public_path__ + "static/media/slider-img-4.940dd926.png";